<div class="card">
    <p-toolbar>
        <div style="justify-content: left; display: flex">
            <div style="padding-right: 1vw">
                <button
                    pButton
                    pRipple
                    class="p-button-text"
                    (click)="expandCollapse('expand')"
                    label="Expand All"
                ></button>
            </div>

            <div style="padding-right: 1vw">
                <button
                    pButton
                    pRipple
                    class="p-button-text"
                    (click)="expandCollapse('collapse')"
                    label="Collapse All"
                ></button>
            </div>
        </div>
    </p-toolbar>

    <div class="table-container indirect-jobs-tree">
        <p-treeTable
            [value]="treeNodes"
            [scrollable]="true"
            scrollHeight="68vh"
            dataKey="key"
            [tableStyle]="{ 'min-width': '120rem' }"
            styleClass="table p-datatable-full"
            (onNodeExpand)="onTreeNodeExpand($event)"
            (onNodeCollapse)="onTreeNodeCollapse($event)"
        >
            <ng-template pTemplate="togglericon" let-expanded>          
                <span class="indirect-tree-toggler-icon" aria-hidden="true">{{
                    expanded ? '−' : '+'
                }}</span>
            </ng-template>
            <ng-template pTemplate="colgroup">
                <colgroup>
                  <col style="width: 4rem" />   <!-- status -->
                  <col style="width: 16rem" />  <!-- job name -->
                  <col style="width: 16rem" />  <!-- labor type -->
                  <col style="width: 18rem" />  <!-- account -->
                  <col style="width: 16rem" />  <!-- paycode -->
                  <col style="width: 8rem" />   <!-- accrue leave -->
                  <col style="width: 8rem" />   <!-- sick -->
                  <col style="width: 8rem" />   <!-- holiday -->
                  <col style="width: 8rem" />  <!-- leave request -->
                  <col style="width: 8rem" />   <!-- lwop -->
                  <col style="width: 8rem" />   <!-- leave payout -->
                  <col *ngIf="isVisible" style="width: 18rem" />  <!-- cost center -->
                  <col style="width: 12rem" />  <!-- first process date -->
                </colgroup>
              </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th></th>
                    <th ttSortableColumn="QB_Name">
                        Job Name
                        <p-treeTableSortIcon field="QB_Name"></p-treeTableSortIcon>
                    </th>
                    <th ttSortableColumn="IndirectType">
                        Labor Type
                        <p-treeTableSortIcon field="IndirectType"></p-treeTableSortIcon>
                    </th>
                    <th ttSortableColumn="AccountListID">
                        Account
                        <p-treeTableSortIcon field="AccountListID"></p-treeTableSortIcon>
                    </th>
                    <th ttSortableColumn="Paycodeid">
                        Paycode
                        <p-treeTableSortIcon field="Paycodeid"></p-treeTableSortIcon>
                    </th>
                    <th ttSortableColumn="AccruedLeave">
                        Accrue Leave
                        <p-treeTableSortIcon field="AccruedLeave"></p-treeTableSortIcon>
                    </th>
                    <th ttSortableColumn="IsSickTask">
                        Sick
                        <p-treeTableSortIcon field="IsSickTask"></p-treeTableSortIcon>
                    </th>
                    <th ttSortableColumn="IsHolidayTask">
                        Holiday
                        <p-treeTableSortIcon field="IsHolidayTask"></p-treeTableSortIcon>
                    </th>
                    <th ttSortableColumn="IsLeaveTask">
                        Leave Request
                        <p-treeTableSortIcon field="IsLeaveTask"></p-treeTableSortIcon>
                    </th>
                    <th ttSortableColumn="LWOPIndicator">
                        LWOP
                        <p-treeTableSortIcon field="LWOPIndicator"></p-treeTableSortIcon>
                    </th>
                    <th ttSortableColumn="LeavePayout">
                        Leave Payout
                        <p-treeTableSortIcon field="LeavePayout"></p-treeTableSortIcon>
                    </th>
                    <th *ngIf="isVisible" ttSortableColumn="CostCenterID">
                        Cost Center Override
                        <p-treeTableSortIcon field="CostCenterID"></p-treeTableSortIcon>
                    </th>
                    <th ttSortableColumn="FirstProcessDate">
                        First Process Date
                        <p-treeTableSortIcon field="FirstProcessDate"></p-treeTableSortIcon>
                    </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                <tr [ttRow]="rowNode" [ngClass]="{ highlight: isSelectedErrorRow(rowData) }">
                    <td>
                        <i
                            class="material-icons status-icon"
                            [ngClass]="{
                                green: statusClass(rowData) === 'green',
                                yellow: statusClass(rowData) === 'yellow',
                                red: statusClass(rowData) === 'red',
                                spin: rowData?.Status?.StatusCode === 99
                            }"
                            [pTooltip]="rowData?.Status?.Message"
                            tooltipPosition="top"
                            [tooltipDisabled]="!rowData?.Status?.Message"
                            (click)="onStatusClick(rowData)"
                            >{{
                                rowData?.Status?.StatusCode === 1
                                    ? 'check_circle'
                                    : rowData?.Status?.StatusCode === 2
                                      ? 'report_problem'
                                      : rowData?.Status?.StatusCode === 99
                                        ? 'autorenew'
                                      : rowData?.Status?.StatusCode >= 3 &&
                                          rowData?.Status?.StatusCode <= 6
                                        ? 'highlight_off'
                                        : ''
                            }}</i
                        >
                    </td>
                    <td
                        [pTooltip]="rowData.QB_Name"
                        tooltipPosition="top"
                        [tooltipDisabled]="!rowData.QB_Name"
                    >
                        <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                        {{ rowData.QB_Name }}
                    </td>
                    <td>
                        <p-dropdown
                            *ngIf="canEditLaborType(rowData)"
                            [options]="indirectTypeOptions()"
                            optionLabel="label"
                            optionValue="value"
                            [ngModel]="rowData.IndirectType"
                            styleClass="w-full"
                            appendTo="body"
                            [pTooltip]="indirectTypeLabel(rowData.IndirectType)"
                            tooltipPosition="top"
                            [tooltipDisabled]="!indirectTypeLabel(rowData.IndirectType)"
                            (onChange)="changeLaborType(rowData, $event.value)"
                        ></p-dropdown>
                        <span
                            *ngIf="!canEditLaborType(rowData)"
                            [pTooltip]="indirectTypeLabel(rowData.IndirectType)"
                            tooltipPosition="top"
                            [tooltipDisabled]="!indirectTypeLabel(rowData.IndirectType)"
                            >{{ indirectTypeLabel(rowData.IndirectType) }}</span
                        >
                    </td>
                    <td>
                        <p-dropdown
                            *ngIf="canEditAccountPaycode(rowData)"
                            [options]="accountOptions()"
                            optionLabel="label"
                            optionValue="value"
                            [ngModel]="rowData.AccountListID"
                            styleClass="w-full"
                            appendTo="body"
                            [pTooltip]="accountLabel(rowData.AccountListID)"
                            tooltipPosition="top"
                            [tooltipDisabled]="!accountLabel(rowData.AccountListID)"
                            (onChange)="changeAccount(rowData, $event.value)"
                        ></p-dropdown>
                        <span
                            *ngIf="!canEditAccountPaycode(rowData)"
                            [pTooltip]="accountLabel(rowData.AccountListID)"
                            tooltipPosition="top"
                            [tooltipDisabled]="!accountLabel(rowData.AccountListID)"
                            >{{ accountLabel(rowData.AccountListID) }}</span
                        >
                    </td>
                    <td>
                        <p-dropdown
                            *ngIf="canEditAccountPaycode(rowData)"
                            [options]="paycodeOptions()"
                            optionLabel="label"
                            optionValue="value"
                            [ngModel]="rowData.Paycodeid"
                            styleClass="w-full"
                            appendTo="body"
                            [pTooltip]="paycodeLabel(rowData.Paycodeid)"
                            tooltipPosition="top"
                            [tooltipDisabled]="!paycodeLabel(rowData.Paycodeid)"
                            (onChange)="changePaycode(rowData, $event.value)"
                        ></p-dropdown>
                        <span
                            *ngIf="!canEditAccountPaycode(rowData)"
                            [pTooltip]="paycodeLabel(rowData.Paycodeid)"
                            tooltipPosition="top"
                            [tooltipDisabled]="!paycodeLabel(rowData.Paycodeid)"
                            >{{ paycodeLabel(rowData.Paycodeid) }}</span
                        >
                    </td>

                    <td class="boolean-cell">
                        <p-checkbox
                            [binary]="true"
                            [ngModel]="rowData.AccruedLeave"
                            [disabled]="!canEditChargeFlag(rowData)"
                            [pTooltip]="rowData.AccruedLeave ? 'Yes' : 'No'"
                            tooltipPosition="top"
                            (onChange)="toggleAccruedLeave(rowData)"
                        ></p-checkbox>
                    </td>
                    <td class="boolean-cell">
                        <p-checkbox
                            [binary]="true"
                            [ngModel]="rowData.IsSickTask"
                            [disabled]="!canEditChargeFlag(rowData)"
                            [pTooltip]="rowData.IsSickTask ? 'Yes' : 'No'"
                            tooltipPosition="top"
                            (onChange)="toggleSick(rowData)"
                        ></p-checkbox>
                    </td>
                    <td class="boolean-cell">
                        <p-checkbox
                            [binary]="true"
                            [ngModel]="rowData.IsHolidayTask"
                            [disabled]="!canEditChargeFlag(rowData)"
                            [pTooltip]="rowData.IsHolidayTask ? 'Yes' : 'No'"
                            tooltipPosition="top"
                            (onChange)="toggleHoliday(rowData)"
                        ></p-checkbox>
                    </td>
                    <td class="boolean-cell">
                        <p-checkbox
                            [binary]="true"
                            [ngModel]="rowData.IsLeaveTask"
                            [disabled]="!canEditChargeFlag(rowData)"
                            [pTooltip]="rowData.IsLeaveTask ? 'Yes' : 'No'"
                            tooltipPosition="top"
                            (onChange)="toggleLeaveRequest(rowData)"
                        ></p-checkbox>
                    </td>
                    <td class="boolean-cell">
                        <p-checkbox
                            [binary]="true"
                            [ngModel]="rowData.LWOPIndicator"
                            [disabled]="!canEditChargeFlag(rowData)"
                            [pTooltip]="rowData.LWOPIndicator ? 'Yes' : 'No'"
                            tooltipPosition="top"
                            (onChange)="toggleLWOP(rowData)"
                        ></p-checkbox>
                    </td>
                    <td class="boolean-cell">
                        <p-checkbox
                            [binary]="true"
                            [ngModel]="rowData.LeavePayout"
                            [disabled]="!canEditChargeFlag(rowData)"
                            [pTooltip]="rowData.LeavePayout ? 'Yes' : 'No'"
                            tooltipPosition="top"
                            (onChange)="toggleLeavePayout(rowData)"
                        ></p-checkbox>
                    </td>
                    <td *ngIf="isVisible">
                        <p-dropdown
                            *ngIf="canEditCostCenter(rowData)"
                            [options]="costCenterOptions()"
                            optionLabel="label"
                            optionValue="value"
                            [ngModel]="rowData.CostCenterID"
                            styleClass="w-full"
                            appendTo="body"
                            [pTooltip]="costCenterLabel(rowData.CostCenterID)"
                            tooltipPosition="top"
                            [tooltipDisabled]="!costCenterLabel(rowData.CostCenterID)"
                            (onChange)="changeCostCenter(rowData, $event.value)"
                        ></p-dropdown>
                        <span
                            *ngIf="!canEditCostCenter(rowData)"
                            [pTooltip]="costCenterLabel(rowData.CostCenterID)"
                            tooltipPosition="top"
                            [tooltipDisabled]="!costCenterLabel(rowData.CostCenterID)"
                            >{{ costCenterLabel(rowData.CostCenterID) }}</span
                        >
                    </td>
                    <td
                        [pTooltip]="formatFirstProcessDate(rowData.FirstProcessDate)"
                        tooltipPosition="top"
                        [tooltipDisabled]="!formatFirstProcessDate(rowData.FirstProcessDate)"
                    >
                        {{ formatFirstProcessDate(rowData.FirstProcessDate) }}
                    </td>
                </tr>
            </ng-template>
        </p-treeTable>
    </div>
</div>
